import { useDispatchTool, useStateTool } from 'app/store/withDevTools';
import React from 'react';
import { RecorrenciaInitState, RecorrenciaReducer } from './recorrenciaReducer';

const RecorrenciaContext = React.createContext();
const RecorrenciaDispatcher = React.createContext();

const RecorrenciaProvider = (props) => {
  const [state, dispatch] = React.useReducer(RecorrenciaReducer, RecorrenciaInitState);

  return (
    <RecorrenciaContext.Provider value={state}>
      <RecorrenciaDispatcher.Provider value={dispatch}>{props.children}</RecorrenciaDispatcher.Provider>
    </RecorrenciaContext.Provider>
  );
};

function RecorrenciaConsumer({ children }) {
  return (
    <RecorrenciaContext.Consumer>
      {(context) => {
        if (context === undefined) {
          throw new Error('RecorrenciaConsumer must be used within a RecorrenciaProvider');
        }

        return children(context);
      }}
    </RecorrenciaContext.Consumer>
  );
}

function useRecorrencia() {
  return [
    useStateTool(RecorrenciaContext, 'RecorrenciaContext'),
    useDispatchTool(RecorrenciaDispatcher, 'RecorrenciaDispatcher'),
  ];
}

export { RecorrenciaProvider, RecorrenciaConsumer, useRecorrencia };
